import _typeof from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'sizeModel_page',
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '箱皮重',
        addFunName: 'logisticHongdeSizeModelAdd',
        modifyFunName: 'logisticHongdeSizeModelModify',
        delFunName: 'logisticHongdeSizeModelDel',
        queryFunName: 'logisticHongdeDriverLogQueryJoinUser',
        detailFunName: 'logisticHongdeDriverLogDetail',
        dicTreeFunName: 'mngDictionaryLowerTree'
      },
      searchForm: {
        waybillId: '',
        sortField: 'create_time'
      },
      formData: {
        model: null,
        size: null,
        weight: null
      },
      rules: {
        model: [{
          required: true,
          message: '箱型不能为空',
          trigger: 'blur'
        }],
        size: [{
          required: true,
          message: '尺寸不能为空',
          trigger: 'blur'
        }],
        weight: [{
          required: true,
          message: '重量不能为空',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '130px',
      emptyFormData: {},
      dicData: {
        sizeUpperCode: 'logistics_hd_container_size',
        configSizes: [],
        configSizeOptions: {},
        shapeUpperCode: 'logistics_hd_container_shape',
        configShapes: [],
        configShapeOptions: {}
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    Promise.all([new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.sizeUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configSizes = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configSizeOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    }), new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.shapeUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configShapes = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configShapeOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    })]).then(function (result) {
      _this.query();
    });
  },
  methods: {
    jsonToContent: function jsonToContent(content) {
      if (!content) {
        return '';
      }
      var arr = JSON.parse(content);
      if (!arr) {
        return '';
      }
      var str = '';
      if (arr.carNumber) {
        str += arr.carNumber;
      }
      return str;
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this2 = this;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this2.initFormData(res.data);
        if (_this2.formData.handle == '修改箱号或铅封号') {
          _this2.formData.oldContent = JSON.parse(_this2.formData.oldContent);
          var oldContainerSealNums = null;
          if (_this2.formData.oldContent.containerSealNums) {
            oldContainerSealNums = _this2.formData.oldContent.containerSealNums.substring(1, _this2.formData.oldContent.containerSealNums.length - 1);
            if (_typeof(oldContainerSealNums) !== Object) {
              oldContainerSealNums = JSON.parse(oldContainerSealNums);
            }
          }
          _this2.formData.newContent = JSON.parse(_this2.formData.newContent);
          var newContainerSealNums = null;
          if (_this2.formData.newContent.containerSealNums) {
            newContainerSealNums = _this2.formData.newContent.containerSealNums;
            if (_typeof(newContainerSealNums) !== Object && _typeof(newContainerSealNums) !== Array) {
              newContainerSealNums = JSON.parse(newContainerSealNums);
            }
          }
          _this2.formData.newContent1 = '';
          for (var i = 0; i < newContainerSealNums.length; i++) {
            _this2.formData.newContent1 += '箱号：' + newContainerSealNums[i].identity + ';铅封号：' + newContainerSealNums[i].sealIdentity + "\r\n";
          }
          _this2.formData.oldContent1 = '';
          if (oldContainerSealNums) {
            for (var i = 0; i < oldContainerSealNums.length; i++) {
              _this2.formData.oldContent1 += '箱号：' + oldContainerSealNums[i].identity + ';铅封号：' + oldContainerSealNums[i].sealIdentity + "\r\n";
            }
          }
        }
        _this2.editDialogTitle = _this2.formData.handle;
        _this2.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this3 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this3.$api[_this3.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this3.$message.success('删除成功');
            _this3.query();
          } else {
            _this3.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this4 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this4.tableData = res.data || [];
        _this4.totalCount = res.count;
        _this4.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this5 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this5.formData.id) {
            _this5.$api[_this5.pageConfig.modifyFunName](_this5.saveFormDataProcess(_this5.formData)).then(function (res) {
              if (res.data) {
                _this5.$message.success('编辑成功');
                _this5.initFormData(_this5.emptyFormData);
                _this5.editDialogShow = false;
                _this5.query();
              } else {
                _this5.$message.error('编辑失败');
              }
            });
          } else {
            _this5.$api[_this5.pageConfig.addFunName](_this5.saveFormDataProcess(_this5.formData)).then(function (res) {
              if (res.data) {
                _this5.$message.success('新增成功');
                _this5.initFormData(_this5.emptyFormData);
                _this5.editDialogShow = false;
                _this5.query();
              } else {
                _this5.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};